import { useOnboardingStore } from '@/stores/onboardingStore';

/**
 * True while the onboarding automation pipeline is actively running —
 * either flagged as running or with a stage still processing. Pages use
 * this to swap "Resume Onboarding" CTAs for a setup-in-progress state
 * (resuming mid-automation just bounces the user around, LIL-440).
 */
export function useAutomationActive(): boolean {
  return useOnboardingStore(
    s => s.automation.isRunning || s.automation.stages.some(st => st.status === 'processing')
  );
}
